import { createDriverUndispatchedCargoTypes, isoDateTime } from "dora-contracts";
import * as t from "io-ts";

export const { driverUndispatchedCargoT, driverUndispatchedCargosT } =
  createDriverUndispatchedCargoTypes({
    dateTime: isoDateTime,
  });

export type DriverUndispatchedCargo = t.TypeOf<typeof driverUndispatchedCargoT>;
export type DriverUndispatchedCargos = t.TypeOf<typeof driverUndispatchedCargosT>;
